/**
 * Devolve a vez ao navegador entre pedaços de um trabalho longo, para nenhum pedaço virar tarefa longa (TBT, DECISOES
 * §44). Sem relógio: `scheduler.yield()` onde existe; senão uma mensagem de `MessageChannel`, que abre uma tarefa nova
 * sem passar pelos temporizadores. `setTimeout` não serve: com o relógio dos testes parado (`page.clock`,
 * `vi.useFakeTimers`), o trabalho nunca terminaria. Sem nenhum dos dois, segue na mesma tarefa.
 */
export function yieldToBrowser(): Promise<void> {
  const scheduler = (globalThis as { scheduler?: { yield?: () => Promise<void> } }).scheduler;
  if (typeof scheduler?.yield === 'function') return scheduler.yield();
  if (typeof MessageChannel !== 'function') return Promise.resolve();
  return new Promise((done) => {
    const channel = new MessageChannel();
    channel.port1.onmessage = () => {
      channel.port1.close();
      done();
    };
    channel.port2.postMessage(null);
  });
}
